import { ChannelTypeEnum } from 'talkplus-sdk';

export interface LiveInfo {
  channelId: string;
  eventId: string;
  streamId: string;
  title: string;
  hlsUrl: string;
  secEventId: string;
  thumUrl: string;
  logoUrl: string;
  chatting: null | ChannelTypeEnum;
  published: Date;
  connState: LIVE_EVENT_CONN_STATE;
  state: LIVE_EVENT_STATE;
}

export interface LiveStateInfo {
  connState: LIVE_EVENT_CONN_STATE;
  state: LIVE_EVENT_STATE;
  streamId?: string;
  channelId?: string;
  eventId?: string;
  hlsUrl?: string;
}

export enum LIVE_EVENT_CONN_STATE {
  READY = 1,
  PLAYINIG = 2,
  FINISHED = 3,
  PAUSED = 4,
}

export enum LIVE_EVENT_STATE {
  ACTIVE = 1,
  DISABLED = 9,
}
